import { render, staticRenderFns } from "./PageCorps.vue?vue&type=template&id=1eea64b0&scoped=true"
import script from "./PageCorps.vue?vue&type=script&lang=ts"
export * from "./PageCorps.vue?vue&type=script&lang=ts"
import style0 from "./PageCorps.vue?vue&type=style&index=0&id=1eea64b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eea64b0",
  null
  
)

export default component.exports